<template>
    <div class="rightStudentPlan">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: "parentMain",
    data(){
        return {
        }
    },

    computed:{
    },
    watch: {
    },
    created() {
    },
    mounted(){

    },
    methods:{
    },
}
</script>

<style scoped lang="less">
    .rightStudentPlan {
        width: 970px;
    }
</style>

